(ns app.domain.custom-link.model
  (:require [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.domain.validators :as validators]))

(def default-custom-link-icon :custom-link.icon/external-link)

(def custom-link-icon->img
  "Map from icon keyword to the public asset path."
  {:custom-link.icon/external-link  "/asset/img/custom-link-external.svg"
   :custom-link.icon/home-link      "/asset/img/custom-link-home.svg"
   :custom-link.icon/attention-link "/asset/img/custom-link-attention.svg"})

(defn custom-link-invalid?
  "Returns true when a custom link is missing required data or the URL is not a valid http(s) URI."
  [{:custom-link/keys [url titles]}]
  (or (str/blank? url)
      (not (validators/valid-uri? url))
      (empty? titles)
      (every? str/blank? (vals titles))))

(defmethod i18n-model/get-localized-string-attrs :entity.type/custom-link [_]
  [:custom-link/titles :custom-link/descriptions])

(defmethod group-model/get-authority-group :entity.type/custom-link
  [custom-link]
  (:group/_custom-links custom-link))
